import type { RefLabelJsonldReadCollectionRefLabel } from "@/networking/api"
import { get_t11n_label } from "@/utils/i18n/t11n"
import { isNotBlank } from "@/utils/ts-utils"
import type { IntlShape } from "react-intl"

export const getRefLabelOptions = <T extends keyof RefLabelJsonldReadCollectionRefLabel>(
  labels: RefLabelJsonldReadCollectionRefLabel[],
  intl: IntlShape,
  field?: T
) => {
  type ValueType = typeof field extends undefined | null | ""
    ? RefLabelJsonldReadCollectionRefLabel
    : NonNullable<RefLabelJsonldReadCollectionRefLabel[NonNullable<T>]>

  return labels.map(lbl => ({
    label: get_t11n_label(lbl, intl),
    value: isNotBlank(field) ? lbl[field] : lbl,
  })) as {
    label: string
    value: ValueType
  }[]
}

export const CLIENT_SEARCH_MIN_CHARS = 2

// Message shown by the client select when it has no option to list: the search only starts at
// CLIENT_SEARCH_MIN_CHARS characters, and the debounced search term may still be pending.
export const getClientSearchMessageId = (inputValue: string, searchTerm: string) => {
  if (inputValue.trim().length < CLIENT_SEARCH_MIN_CHARS)
    return "userSharedData.interbu.modal.steps.0.search.minChars"
  if (inputValue !== searchTerm) return "loading.generic.title"
  return "userSharedData.interbu.modal.steps.0.search.noResult"
}
